import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    viewBox="0 0 21.167 21.167"
    {...props}
  >
    <g
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={5.369}
      transform="translate(.065 -.074) scale(.26518)"
    >
      <ellipse id="backgroung-svg" cx={39.625} cy={40.147} rx={37.266} ry={37.243} />
      <path id="backgroung-svg2" d="M20.704 29.004h11.393M48.048 29.004h11.393M25.282 53.953h29.297" />
    </g>
  </svg>
)
export default SvgComponent
